import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// Style-Fonts
import '../src/fonts.css';

ReactDOM.render(<App />, document.getElementById('root'));
